import { MeQuery } from 'lib/home/generated/types/api';
import { selectFrequencyFromMe } from '../../../util/helpers';
import { DefaultLayout, ChangeSubscriptionFrequencyForm } from '../../../components';
import { Card, CardContent } from 'lib/ui-components/src';

const ChangeFrequencyPage = () => {
  return (
    <DefaultLayout backTo="/account">
      {({ me }: { me: MeQuery['me'] }) => {
        const frequency = selectFrequencyFromMe(me);

        return (
          <Card>
            <CardContent>
              <h2>Change Your Subscription Frequency</h2>
              <p>Select the delivery frequency that works best for your schedule.</p>
              {frequency && <ChangeSubscriptionFrequencyForm initialValues={{ frequency }} />}
            </CardContent>
          </Card>
        );
      }}
    </DefaultLayout>
  );
};

export default ChangeFrequencyPage;
